import { Excess } from 'scenes/common/types';
import { ExcessCode, ExcessType } from 'scenes/motor/types';
import { toMotorCoverType } from './coverage';

import {
  WireMotorExcess,
  WireExcessCode,
  WireMotorExcessType,
  WireMotorQuotePayload,
} from '../types';

const mapExcessCode = (
  wireExcessCode: WireExcessCode | undefined
): ExcessCode | undefined => {
  switch (wireExcessCode) {
    case WireExcessCode.ExcessForDriverInSpecifiedRange:
      return ExcessCode.ExcessForDriverInSpecifiedRange;
    case WireExcessCode.InexperienceExcess:
      return ExcessCode.InexperienceExcess;
    case WireExcessCode.UnderAgedDriverExcess:
      return ExcessCode.UnderAgedDriverExcess;
    case WireExcessCode.VoluntaryAmt:
      return ExcessCode.VoluntaryAmt;
    case WireExcessCode.BaseAmt:
      return ExcessCode.BaseAmt;
    default:
      return undefined;
  }
};

const mapExcessTypes = (wireExcessType: WireMotorExcessType): ExcessType => {
  switch (wireExcessType) {
    case WireMotorExcessType.Additional:
      return ExcessType.Additional;
    case WireMotorExcessType.Standard:
      return ExcessType.Standard;
    case WireMotorExcessType.Imposed:
      return ExcessType.Imposed;
    case WireMotorExcessType.Under20:
      return ExcessType.Under20;
    case WireMotorExcessType.VehicleModification:
      return ExcessType.VehicleModification;
    case WireMotorExcessType.Voluntary:
      return ExcessType.Voluntary;
    default:
      return ExcessType.Unspecified;
  }
};

const toExcess = (e: WireMotorExcess): Excess => ({
  ...e,
  type: mapExcessTypes(e.type),
  code: mapExcessCode(e.code),
  name: toMotorCoverType(e.name),
});

export const unmarshalExcesses = (quote: WireMotorQuotePayload) =>
  quote.excesses.map(toExcess);

export const unmarshalSelectedExcess = (quote: WireMotorQuotePayload) =>
  quote.excesses
    .filter((e) => e.selected && e.name === quote.coverType)
    .map(toExcess)[0];
